import { Box, Grid, Stack, Typography } from "@mui/material";

import COLORS from "../../../../styles/colors";
import { ICONS_MAP, OUR_OFFERINGS } from "./constants";

const OurOfferings = () => {
  const OFFERINGS_LIST: Array<{
    icon: string;
    title: string;
    description: string;
  }> = [
    {
      icon: ICONS_MAP.SAAS_DEVELOPMENT,
      title: "SaaS Development",
      description:
        "Gain seamless scalability and lower entry costs with our SaaS offerings, allowing you to reach a global audience effortlessly.",
    },
    {
      icon: ICONS_MAP.PRODUCT_IDEATION,
      title: "Product Ideation & Consultation",
      description:
        "From identifying your target audience to prioritizing features and crafting a clear value proposition, get a product that aligns with market needs and investor expectations.",
    },
    {
      icon: ICONS_MAP.UI_UX_DESIGN,
      title: "UI/UIX Design",
      description:
        "Stand out in the market with a unique brand identity, while our designs minimize support costs and boost conversion rates, leading to improved user retention.",
    },
    {
      icon: ICONS_MAP.MVP,
      title: "MVP Development",
      description:
        "Test the market with minimal investment, gathering valuable feedback from early adopters to refine your product.",
    },
    {
      icon: ICONS_MAP.SCALING_MAINTENANCE,
      title: "Scaling & Maintenance",
      description:
        "Continuous maintenance and proactive monitoring guarantee ongoing reliability, security, and performance, supported by a scalable infrastructure for enhanced customer satisfaction and loyalty.",
    },
  ];

  return (
    <Box bgcolor={COLORS.WHITE} px={4} py={12}>
      <Typography
        variant="h4"
        textAlign="center"
        color={COLORS.DARK_BLUE}
        fontWeight="600"
        fontSize="30px"
      >
        {OUR_OFFERINGS}
      </Typography>
      <Typography
        mt={2}
        variant="h5"
        textAlign="center"
        color={COLORS.DARK_BLUE}
      >
        From concept to growth, we've got you covered. Dive into our
        comprehensive services for all stages of your software journey.
      </Typography>
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        mt={10}
        rowGap={4}
        columnGap={2}
        px={{ xs: 0, sm: 0, md: 0, lg: 10, xl: 10 }}
      >
        {OFFERINGS_LIST.map(({ icon, title, description }) => (
          <Grid
            item
            key={title}
            alignItems="center"
            textAlign="center"
            width={180}
            spacing={4}
          >
            <Stack justifyContent="space-between" spacing={2}>
              <Box>
                <img alt={title} src={icon} height="60px" />
              </Box>
              <Typography
                textAlign="center"
                fontWeight="600"
                fontSize="19px"
                color={COLORS.DARK_BLUE}
              >
                {title}
              </Typography>
              <Typography color={COLORS.DARK_BLUE} variant="body1">{description}</Typography>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default OurOfferings;
